export default __webpack_public_path__ + "static/media/Bitterfrost.000a3c4d.jpg";